/**
 * Environment-aware logging utility
 *
 * In development: logs to console
 * In production: can be configured to send to error tracking service
 *
 * Uses import.meta.env.DEV to avoid circular dependency with @/config/env.
 */

const isDev = import.meta.env.DEV;

interface LogLevel {
  error: (...args: unknown[]) => void;
  warn: (...args: unknown[]) => void;
  info: (...args: unknown[]) => void;
  debug: (...args: unknown[]) => void;
}

/**
 * Logger utility that respects environment
 * - Development: logs to console
 * - Production: can be extended to send to error tracking service
 */
export const logger: LogLevel = {
  error: (...args: unknown[]) => {
    if (isDev) {
      console.error(...args);
    }
    // In production, this will be replaced with error tracking service
    // when Sentry is integrated
  },
  warn: (...args: unknown[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },
  info: (...args: unknown[]) => {
    if (isDev) {
      console.info(...args);
    }
  },
  debug: (...args: unknown[]) => {
    if (isDev) {
      console.debug(...args);
    }
  },
};
